import { HttpClient } from "services/HttpClient";
import { PatientRegion, PatientRegionDetail } from "types/PatientRegion";
import { delay } from "../utils/general";
import {
  ApiPaginatedResponse,
  CommonApiParams,
  FilterDetailsParams,
} from "../types/common";
import { regions } from "../__mocks__/regons";
import { Joint } from "../types/Region";
import { getData, getRoleData } from "../contexts/authContext";
import { USER_GROUPS } from "constants/roles";
import qs from "qs";
import * as cognito from "../libs/cognito";

export class PatientRegionsRepository extends HttpClient {
  public getPatientRegions = async (
    params: CommonApiParams,
    searchingFor?: string,
    detailedFilter?: FilterDetailsParams
  ) => {
    const token = await getData("idToken");
    const roles = (await getRoleData()) ?? [];
    let endpoint = "";
    if (roles.includes(USER_GROUPS.COACH)) {
      endpoint = "/patient-region/athletes";
    } else {
      endpoint = "/patient-region";
    }
    let patientRequestParams: any = {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    if (detailedFilter) {
      patientRequestParams = {
        params: {
          ...params,
          ...detailedFilter,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
        paramsSerializer: (params: any) => {
          return qs.stringify(params, { arrayFormat: "brackets" });
        },
      };
    }

    if (searchingFor) {
      patientRequestParams = {
        params: {
          ...params,
          search: searchingFor,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
    }

    console.log({ patientRequestParams });
    const { data } = await this.instance.get<
      ApiPaginatedResponse<PatientRegion>
    >(endpoint, patientRequestParams);
    return data;
  };

  public getPatientRegionDetails = async (patientId: string) => {
    const token = await getData("idToken");
    const { data } = await this.instance.get<PatientRegionDetail[]>(
      `/patient-region/details?patientId=${patientId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  };

  public getJoints = async () => {
    const token = await getData("idToken");

    const { data } = await this.instance.get<Joint[]>("/joint", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  };

  // eslint-disable-next-line class-methods-use-this
  public getRegions = async () => {
    // TODO: add real request here: DON'T FORGET TO ADD AUTHORIZATION HEADER
    await delay(1000);
    return regions;
  };

  constructor() {
    super(process.env.REACT_APP_BASE_URL as string, () => {
      cognito.signOut(true);
    });
  }

  private static classInstance?: PatientRegionsRepository;

  public static getInstance() {
    if (!this.classInstance) {
      this.classInstance = new PatientRegionsRepository();
    }
    return this.classInstance;
  }
}
